import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const useSocialProofAuthUIExperiment = (triggerExperiment = true) => {
  useBinaryExperiment(FLAG.MW_8_3_SOCIAL_PROOF_MESSAGE, { triggerExperiment });
};
